import { makeGetRequest } from './makeRequest';

const getWishlist = () => makeGetRequest('/api/users/self/wishlist');

export default getWishlist;
